import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './styles/tokens.css';
import './styles.css';
import { initLogRocket } from './lib/logrocket.js';
import { initLiquidGlass } from './lib/liquidGlass.js';

import Landing from './pages/Landing.jsx';
import Record  from './pages/Record.jsx';
import Asker from './pages/Asker.jsx';
import ThankYou from './pages/ThankYou.jsx';
import Dashboard from './pages/Dashboard.jsx';
import DashboardSubmission from './pages/DashboardSubmission.jsx';
import AdminLogin from './pages/AdminLogin.jsx';

// Initialize LogRocket before React mounts so the very first paint and
// any startup errors get captured. identifyUser() is called per-page
// once we know who the visitor is (customer via /api/submission, admin
// via the __vt_admin_email cookie).
initLogRocket();
initLiquidGlass();

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        {/* Landing page — what visitors see if they hit the bare domain. */}
        <Route path="/" element={<Landing />} />

        {/* Customer-facing recorder. `r` stands for "record". */}
        <Route path="/r/:token" element={<Record />} />
        <Route path="/ask/:token" element={<Asker />} />
        <Route path="/r/:token/thanks" element={<ThankYou />} />

        {/* Internal dashboard, cookie-auth'd. */}
        <Route path="/dashboard/login" element={<AdminLogin />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/dashboard/submissions/:id" element={<DashboardSubmission />} />

        {/* Catch-all → root. */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
